import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'react-query';

import { fetchReportData, type ReportDateRangeValue } from '../api/fetchReportData';

function serializeDateRange(dateRange: ReportDateRangeValue): string {
    return `${dateRange.range}:${dateRange.customStart ?? ''}:${dateRange.customEnd ?? ''}`;
}

type UseReportDataOptions = {
    reportId: string;
    eventId: number | undefined;
    dateRange: ReportDateRangeValue;
    timezone: string;
    enabled?: boolean;
};

export function useReportData<T = Record<string, unknown>>({
    reportId,
    eventId,
    dateRange,
    timezone,
    enabled = true,
}: UseReportDataOptions) {
    const dateRangeKey = serializeDateRange(dateRange);

    return useQuery({
        queryKey: queryKeys.reports.data(eventId ?? 0, reportId, dateRangeKey),
        queryFn: () => fetchReportData<T>(reportId, eventId!, dateRange, timezone),
        enabled: enabled && Boolean(eventId),
    });
}
